<template>
  <!--
    Example Data
    {
      name: "fieldName", input_type: :field, field_type: "number",
      default: "some <optional> default val",
      unit_of_measure: "optional UOM", label: "optional label"
    }
  -->
  <v-row>
    <v-col md="3">
      <div class="mr-5 mt-6">
        <div class="text-right subtitle font-weight-bold">{{ fieldLabel() }}</div>
      </div>
    </v-col>
    <v-col class="d-flex d-inline" md="9" >
      <v-text-field
        :label="value.name | titleize"
        :suffix="value.unit_of_measure"
        :type="value.field_type"
        :value="valOrDefault"
        v-on:change="updateQueryParamValue(value.name, $event)"
        class="mr-6"
        :rules="vruleFieldRequired"
        required
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import validationMixin from '@/validators/validations_mixin'

export default {
  name: 'field-input',
  inputType: 'field',
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      require: true
    },
    paramName: {
      type: String,
      require: true
    },
    modelValue: {
      type: Object,
      require: true
    },
    errorMessages: {
      type: Array
    }
  },
  data: function () {
    return {}
  },
  computed: {
    valOrDefault () {
      if (this.modelValue[this.value.name]) {
        return this.modelValue[this.value.name]
      } else if (this.value.default) {
        this.updateQueryParamValue(this.value.name, this.value.default)
        return this.value.default
      } else {
        return ''
      }
    }
  },
  methods: {
    updateQueryParamValue (key, value) {
      this.$emit('update-query-param-value', { name: this.paramName, key: key, value: value })
    },
    fieldLabel () {
      return this.value.label || this.value.name
    }
  }
}
</script>
